import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { ITemplate } from 'entities/template/template';
import { archiveTemplate } from '../sections/template-list/utils/queries';
import { useTemplatesListDispatch } from '../sections/template-list/context/UseTemplatesListContext';
import useNotifications from 'core/notifications/useNotifications';
import { invalidateTemplateQueries } from '../sections/template-list/utils/invalidateTemplateQueries';

export function useArchiveTemplate(selectedTemplate: ITemplate, getQueryKeysToInvalidate: () => string) {
  const { t } = useTranslation(['common', 'designs', 'supportedLanguages', 'templates']);
  const { showNotification } = useNotifications();
  const queryClient = useQueryClient();
  const dispatch = useTemplatesListDispatch();

  return useMutation(
    () =>
      archiveTemplate({
        siteId: selectedTemplate.siteId,
        templateId: selectedTemplate.id,
        channel: selectedTemplate.channel,
        campaignType: selectedTemplate.type,
        t,
      }),
    {
      onSuccess: () => {
        showNotification(t('designs:designGallery.form.comment.notifications.archiveTemplateSuccess'), 'normal');
        invalidateTemplateQueries(queryClient, selectedTemplate, getQueryKeysToInvalidate());
        dispatch({
          type: 'RESET_SELECTED_TEMPLATE',
        });
      },
      onError: (error: unknown) => {
        const errorObj = error as { response?: { data?: { message?: string } }; message?: string };
        const errorMessage =
          errorObj?.response?.data?.message ||
          errorObj?.message ||
          t('designs:designGallery.form.comment.notifications.archiveTemplateError');
        showNotification(errorMessage, 'error');
      },
    },
  );
}
